import { AuthUser } from '51trips-frontend-core'
import { AdditionalUserInfo, User } from 'firebase/auth'

const authUserConverter = {
  fromGoogle: (user: User, additionalUserInfo: AdditionalUserInfo | null) => {
    let id: string | undefined
    if (typeof user.uid === 'string') {
      id = user.uid
    }

    let fullName: string | undefined
    if (
      additionalUserInfo?.profile !== null &&
      typeof additionalUserInfo?.profile['given_name'] === 'string'
    ) {
      fullName = additionalUserInfo?.profile['given_name']
    }

    let email: string | undefined
    if (user.email) {
      email = user.email
    }

    let profileImageURL: string | undefined
    if (
      additionalUserInfo?.profile !== null &&
      typeof additionalUserInfo?.profile['picture'] === 'string'
    ) {
      profileImageURL = additionalUserInfo?.profile['picture']
    }

    let isNewUser: boolean | undefined
    if (typeof additionalUserInfo?.isNewUser === 'boolean') {
      isNewUser = additionalUserInfo.isNewUser
    }

    return new AuthUser(id, fullName, email, profileImageURL, isNewUser)
  },

  fromApple: (user: User, additionalUserInfo: AdditionalUserInfo | null) => {
    let id: string | undefined
    if (typeof user.uid === 'string') {
      id = user.uid
    }

    let email: string | undefined
    if (user.email) {
      email = user.email
    }

    let isNewUser: boolean | undefined
    if (typeof additionalUserInfo?.isNewUser === 'boolean') {
      isNewUser = additionalUserInfo.isNewUser
    }

    return new AuthUser(id, undefined, email, undefined, isNewUser)
  }
}

export default authUserConverter
